<script>
    import Fa from 'svelte-fa'
    import {link,push,querystring} from 'svelte-spa-router'
    import * as qs from 'qs';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faUserPlus,faHomeUser,faSignIn,faMinus,faMobileScreenButton,faCircleRight,faKey,faLock, faSave } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'

    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let myLink = '/register'

    let username = ""
    let password = ""
    let password2 = ""
    let customerphone = ''
    let step1 = true
    let step2 = false
    let step3 = false
    let step21 = false
    let otp_num1 = ""
    let otp_num2 = ""
    let otp_num3 = ""
    let otp_num4 = ""

    let otp1
    let otp2
    let otp3
    let otp4
    let isotp = 1
    let customeraccRepass = '';
    if(dataSetting.is_otp=='' || dataSetting.is_otp==undefined){
        isotp = 0
    }else{
        isotp = dataSetting.is_otp
    }
    

    let paramsx = new URLSearchParams($querystring);
	let logintoken = paramsx.get('token')

    let otp_token = ""


    async function setStep1() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep1", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                member_tel:customerphone,
                is_otp:isotp
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            otp_token = json.payload.token
            step1 = false
            if(isotp==1){
                step21 = false
                step2 = true
            }else if(isotp==0){
                step2 = false
                step21 = true
            }else{

            }
            step3 = false
		}else{
            Swal.fire({
                heightAuto: false,
                title: 'แจ้งเตือน !',
                text: json.message,
                icon: 'warning',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep2() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep2", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                token:otp_token,
                otp:otp_num1.toString()+otp_num2.toString()+otp_num3.toString()+otp_num4.toString()
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            step1 = false
            step2 = false
            step3 = true
		}else{
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: json.message,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep21(){
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep21", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                token:otp_token,
                member_tel:customerphone,
                member_acc:customeraccRepass
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            otp_token = json.payload.token
            step1 = false
            step21 = false
            step2 = false
            step3 = true
             setTimeout(() => {
                var obc = document.getElementById('password1')
                obc.focus();
            }, 500);
		}else{
            Swal.fire({
                heightAuto: false,
                title: 'แจ้งเตือน !',
                text: json.message,
                icon: 'warning',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep3() {
        if(password1 === "" || password2 === "" || password3 === "" || password4 === "" || password1 ==undefined  || password2 ==undefined || password3 ==undefined || password4 ==undefined){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุรหัสผ่านให้ครบถ้วน",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            return
        }else{
            password =password1+''+password2+''+password3+''+password4
            const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep3", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-api-appid': window.localStorage.getItem("appid")
                },
                body: qs.stringify({
                    token:otp_token,
                    member_password:password
                })
            })
            const json = await res.json()
            if (json.statusCode==200) {
                Swal.fire({
                    heightAuto: false,
                    title: 'ทำรายการสำเร็จ',
                    text: "",
                    icon: 'success',
                    confirmButtonText: 'OK' 
                })
                push("/auth")
            }else{
                Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            }
        }
    }
    
    let password1 = ""
    let password3 = ""
    let password4 = ""
    function numberonlyDot(evt){
        var e = evt;
        if(window.event){ // IE
            var charCode = e.keyCode;
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) ) window.event.returnValue = false;
        } else if (e.which) { // Safari 4, Firefox 3.0.4
            var charCode = e.which
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) && length!=0) charCode = e.preventDefault();
        }
    }
    const onKeyUp1 = (event) => {
        if(event.target.value>=0){
            var obc = document.getElementById('password2')
            obc.focus();
        }
    }
    const onKeyUp2 = (event) => {
        if(event.target.value>=0){
            var obc = document.getElementById('password3')
            obc.focus();
        }
    }
    const onKeyUp3 = (event) => {
        if(event.target.value>=0){
            var obc = document.getElementById('password4')
            obc.focus();
        }
    }
    const onKeyUp4 = (event) => {
    }
    function numberonly(evt){
        var e = evt;
        var inputElement = evt.target;
        var inputValue = inputElement.value;
        var length = inputValue.length;
        if(window.event){ // IE
            var charCode = e.keyCode;
           if(length>0){window.event.returnValue = false;}
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) ) window.event.returnValue = false;
        } else if (e.which) { // Safari 4, Firefox 3.0.4
            var charCode = e.which
            if(length>0){charCode = e.preventDefault()}
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) && length!=0) charCode = e.preventDefault();
        }
    }
    $: {

	}
</script>
<div class="row pt-2 logins"> 
    <div class="col-6">
        <a href="{dataSetting.homepage}" class="btn btn-outline-secondary btn-sm btn-gd btn-news" style="color:#18ab8f !important;border:1px solid #18ab8f !important;--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .7rem;"><Fa icon={faHomeUser} /> หน้าหลัก</a>
    </div>
    <div class="col-6 text-end">
        <a href="{dataSetting.lineurl}" target="_blank"><span class="badge rounded-pill text-bg-success"><Fa icon={faLine} size="lg"/> {dataSetting.lineid}</span></a>
    </div> 
    
    <div class="col-3 mt-5"></div>
    <div class="col-6 text-center mt-5">
        <img src="{dataSetting.logo}" class="img-fluid">
    </div>
    <div class="col-12 mt-3">
        <div class="card">
            <div class="card-body">
                {#if step1}
                <div class="row">
                    <div class="mb-1 text-center">
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <div class="mb-3 text-center">
                        
                        <h6>รีเซ็ตรหัสผ่าน (PIN)</h6>
                    </div>
                    <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAACLn-OIe36odM6b" data-callback="javascriptCallback"></div> -->
                    <div class="mb-3">
                        <label for="customerphone" class="form-label"><Fa icon={faMobileScreenButton} /> เบอร์โทรศัพท์</label>
                        <input type="text" class="form-control rounded-pill text-center" id="customerphone" placeholder="เบอร์โทรศัพท์" bind:value={customerphone}>
                    </div>
                    
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd btn-news"  on:click={() => setStep1()}  style="color:#18ab8f !important" >ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step2}
                <div class="row">
                    <div class="mb-1 text-center">
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <div class="mb-3 text-center">
                        <h6>รีเซ็ตรหัสผ่าน (PIN)</h6>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faMobileScreenButton} /> OTP</label>
                        <div class="row">
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num1} bind:this={otp1} on:keyup={() => otp2.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num2} bind:this={otp2} on:keyup={() => otp3.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num3} bind:this={otp3} on:keyup={() => otp4.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num4} bind:this={otp4} >
                            </div>
                        </div>
                        
                        
                    </div>
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd btn-news" on:click={() => setStep2()}  style="color:#18ab8f !important">ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step21}
                <div class="row">
                    <div class="mb-1 text-center">
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <div class="mb-3 text-center">
                        <h6>รีเซ็ตรหัสผ่าน (PIN)</h6>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faMobileScreenButton} /> เลขที่บัญชี</label>
                        <input type="text" class="form-control rounded-pill text-center" on:keypress={() => numberonlyDot(event)} id="customeraccRepass" placeholder="เลขที่บัญชี" bind:value={customeraccRepass}>
                    </div>
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd btn-news" on:click={() => setStep21()}  style="color:#18ab8f !important">ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step3}
                <div class="row">
                    <div class="mb-1 text-center">
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <div class="mb-3 text-center">
                        <h6>รีเซ็ตรหัสผ่าน (PIN)</h6>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label"><Fa icon={faKey} /> รหัสผ่านใหม่  (PIN)</label>
                        <div style="display: flex;">
                            <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 5px 0px 0px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp1}  id="password1" placeholder="" bind:value={password1} >
                            <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 5px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp2}  id="password2" placeholder="" bind:value={password2} >
                            <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 5px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp3}  id="password3" placeholder="" bind:value={password3} >
                            <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 0px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp4}  id="password4" placeholder="" bind:value={password4} >
                        </div>
                    </div>
                    
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd btn-news" on:click={() => setStep3()}  style="color:#18ab8f !important">ยืนยัน <Fa icon={faSave} /></button>
                    </div>
                </div>
                {/if}
            </div>
          </div>
    </div>
</div>
<style>
    :global(.themes.darkred>.row .card){
        padding: 10px 20px 10px 20px !important;
    }
    :global(.themes.default .logins){
        padding: 15px !important;
    }
    :global(.row.logins){
        margin: 0px !important;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance: textfield;
    }
    .themes.default .logins .card{
        background-color: #fff !important;
    }
    .themes.default .logins .card input::placeholder{
        color:rgba(252, 252, 252, 0.699);
        opacity: 0.5;
        font-size: 12px;
    }
    .themes.default .logins .card input{
        background: #171717;
        color: #FFF;
        border-radius: 10px !important;
    }
    .themes.default .logins .no-padding{
        padding: 0px !important;
    }
    .themes.default .logins .btn-news{
        border-radius: 10px !important; 
    }
    .themes.default .logins .col-6 button{
        width: 100% !important;
    }
    .themes.default .logins .col-12 hr{
        border-top: 0.5px solid rgb(52 52 52 / 90%) !important;
    }
    .themes.default.nblue .logins .card{
        background-color: #3192d7  !important;
    }
    .themes.default.nblue .logins .card label{
        color: #FFF !important;
    }
    .themes.default.nblue .logins .card .btn-home-admin{
        border: 1px solid #FFF !important;
        color: #FFF !important;
    }
    .themes.default.ngold .logins .card{
        background: linear-gradient(135deg, #f2e06b, #a47005 30%, #fefd98 70%, #debe56) !important;
    }
    .themes.default.ngreen .logins .card{
       background: linear-gradient(135deg, #6bf2da, #05a44c 30%, #98fec1 70%, #56de6e) !important;
    }
    .themes.default.norange .logins .card{
       background: linear-gradient(135deg, #f2a46b, #a44e05 30%, #fecc98 70%, #de8956) !important;
    }
    .themes.default.npink .logins .card{
       background: linear-gradient(135deg, #f26bda, #a40556 30%, #fe98f1 70%, #de56a6) !important;
    }
    .themes.default.npurple .logins .card{
       background: linear-gradient(135deg, #a06bf2, #6005a4 30%, #d798fe 70%, #ab56de) !important;
    }
    .themes.default.npurple .logins .card label{
        color: #FFF !important;
    }
    .themes.default.npurple .logins .card .btn-home-admin{
        border: 1px solid #FFF !important;
        color: #FFF !important;
    }
    .themes.default.nred .logins .card{
       background: linear-gradient(135deg, #f26b6b, #a40505 30%, #fe9898 70%, #de5656) !important;
    }
    .themes.default.nred .logins .card label{
        color: #FFF !important;
    }
    .themes.default.nred .logins .card .btn-home-admin{
        border: 1px solid #FFF !important;
        color: #FFF !important;
    }
</style>